export * from '@primeuix/themes/aura/confirmpopup';
export { default } from '@primeuix/themes/aura/confirmpopup';
